import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { environment } from '@coin/shared/core/util-environments';
import { UpdateNotificationsService } from '@coin/shared/core/util-helpers';
import { MatIcon } from '@angular/material/icon';
import { FeatureFlagDirective } from '@coin/shared/core/feature-directives';
import { UpdateNotifierComponent } from '@coin/shared/core/ui-storybook';
import { UserMenuComponent } from '@coin/shared/auth/feature';

@Component({
  selector: 'admin-app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FeatureFlagDirective, MatIcon, UserMenuComponent, UpdateNotifierComponent]
})
export class HeaderComponent {
  protected updateNotifications = inject(UpdateNotificationsService);

  get currentEnvironment(): typeof environment {
    return environment;
  }
}
